var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegoloAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 30.997126,19.704021 v 10.396552 c 0,0.09195 -0.01436,0.178162 -0.04023,0.261494 -0.112068,0.364944 -0.454022,0.632184 -0.859194,0.632184 H 19.70115 c -0.497128,0 -0.899426,-0.405172 -0.899426,-0.899424 v -8.252874 c 0,-0.0431 0,-0.08333 0,-0.126436 v -2.011496 c 0,-0.497126 0.402298,-0.899424 0.899426,-0.899424 h 10.399424 c 0.431036,0 0.795978,0.30747 0.879312,0.71839 0.01436,0.06035 0.02011,0.117816 0.02011,0.181034 z",
    id: "path1",
    style: {
      fill: "#303030",
      strokeWidth: 0.287356
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 30.997126,19.704021 v 10.396552 c 0,0.09195 -0.01436,0.178162 -0.04023,0.261494 -0.112068,0.364944 -0.454022,0.632184 -0.859194,0.632184 H 19.70115 c -0.497128,0 -0.899426,-0.405172 -0.899426,-0.899424 v -8.252874 c 0,-0.0431 0,-0.08333 0,-0.126436 v -2.011496 c 0,-0.497126 0.402298,-0.899424 0.899426,-0.899424 h 10.399424 c 0.431036,0 0.795978,0.30747 0.879312,0.71839 0.01436,0.06035 0.02011,0.117816 0.02011,0.181034 z",
    id: "path2",
    style: {
      fill: "#4d4d4d",
      strokeWidth: 0.287356
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 30.100574,1.002874 H 19.704022 c -0.497126,0 -0.899424,0.402298 -0.899424,0.899425 v 8.25 c 0,1.353448 -0.54023,2.652298 -1.494254,3.609194 l -3.545976,3.543104 c -0.954024,0.956896 -2.255748,1.494252 -3.606322,1.494252 H 6.454023 c -0.635058,0 -1.146552,-0.514366 -1.146552,-1.14655 v -3.31322 c 0,-0.635056 0.514368,-1.146551 1.146552,-1.146551 h 5.844827 c 0.405172,0 0.744254,-0.267241 0.859196,-0.632184 0.02586,-0.08333 0.04023,-0.16954 0.04023,-0.261494 V 1.899425 c 0,-0.06322 -0.0057,-0.120689 -0.02012,-0.181034 C 13.094826,1.307471 12.729886,1 12.29885,1 H 1.899425 C 1.402299,1 1,1.402299 1,1.899425 V 3.91092 c 0,0.0431 0,0.08333 0,0.126436 v 8.252873 c 0,0.494253 0.405172,0.899426 0.899425,0.899426 h 0.908046 c 0.635058,0 1.146552,0.514368 1.146552,1.146552 v 3.313218 c 0,0.635058 -0.514368,1.146552 -1.146552,1.146552 H 1.905172 c -0.497126,0 -0.899425,0.402298 -0.899425,0.899424 v 10.399426 c 0,0.494252 0.405173,0.899424 0.899425,0.899424 h 10.399426 c 0.497126,0 0.899424,-0.405172 0.899424,-0.899424 v -8.252874 c 0,-1.350574 0.537358,-2.6523 1.494254,-3.606322 l 3.543104,-3.545976 c 0.956896,-0.954024 2.255746,-1.494253 3.609194,-1.494253 h 8.25 C 30.597702,13.195402 31,12.793103 31,12.295977 V 1.899425 C 31,1.402299 30.597702,1 30.100574,1 Z",
    id: "path3",
    style: {
      fill: "#000000",
      strokeWidth: 0.287356
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegoloAi);
export default __webpack_public_path__ + "static/media/regolo-ai.ce8e59530050979b92ff5dd746b0d173.svg";
export { ForwardRef as ReactComponent };